import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import BaseChip from "@/components-UI/BaseChip.vue";
import ListItemText from "@/components-UI/list/items/ListItemText.vue";
import { useRouter } from "vue-router/composables";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import SvgCopy from "@/assets/icons/copy2.svg";
import { useCopyText } from "@/utils/copyText";
import { IStatus } from "@/types";
import BaseStatus from "@/components-UI/BaseStatus.vue";

interface Props {
    item?: Record<string, any>,
    value: string,
    routeName: string,
    routeText: string,
    query?: string[],
    additionalText?: string,
    status?: IStatus,
    isCopyTooltip?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemRoute',
  props: {
    item: null,
    value: null,
    routeName: null,
    routeText: null,
    query: null,
    additionalText: null,
    status: null,
    isCopyTooltip: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    item?: Record<string, any>,
    value: string,
    routeName: string,
    routeText: string,
    query?: string[],
    additionalText?: string,
    status?: IStatus,
    isCopyTooltip?: boolean
}



const router = useRouter();

const route = computed(() => {
    const name = props.routeName;
    const params = { id: props.value };
    const query = getQuery();
    return router.resolve({ name, params, query }).href;
});

const getQuery = () => {
    return props.query ? props.query.reduce((acc, q) => ({ ...acc, [q]: props.item[q] }), {}) : '';
};

const copyValue = () => {
    const value = props.item[props.routeText];
    useCopyText(value, 'Скопировано');
};

const getStatus = () => {
    return typeof props.status === 'function' ? props.status(props.item) : props.status;
};


return { __sfc: true,props, router, route, getQuery, copyValue, getStatus, BaseChip, ListItemText, BaseTooltip, SvgCopy, BaseStatus }
}

})